import { useDesktopSidebar } from './useDesktopSidebar';
import useDimensions from './useDimensions';
import { useMobileSidebar } from './useMobileSidebar';
export function useSidebar() {
  const [isMobileSidebarOpened] = useMobileSidebar();
  const [isDesktopSidebarOpened] = useDesktopSidebar();
  const {
    isMobile
  } = useDimensions();
  return isMobile ? isMobileSidebarOpened : isDesktopSidebarOpened;
}